import React, { useState } from 'react';
import { AvatarWrapper } from './styled';

interface AvatarProps {
  fullName: string;
  photoUrl: string;
  showInitials?: boolean;
  email?: string;
  size?: number;
}

export const Avatar: React.FC<AvatarProps> = props => {
  const { fullName = '', photoUrl, showInitials = false, email = '', size = 80 } = props;
  const [ imageLoadFailed, setImageLoadFailed ] = useState(false);
  const isImageVisible = !showInitials && photoUrl && !imageLoadFailed;

  let firstLetter = '';
  let secondLetter = '';
  if (fullName) {
    const [ firstName = '', lastName = '' ] = fullName.split(/\s+/);
    firstLetter = firstName[0];
    secondLetter = lastName ? lastName[0] : lastName;
  }
  else if (email) {
    firstLetter = email[0];
    secondLetter = email[1];
  }

  const handleFailedLoadImage = () => setImageLoadFailed(true);

  return (
    <AvatarWrapper size={size} imageVisible={isImageVisible}>
      {isImageVisible
        ? <img src={photoUrl} alt={fullName || email} onError={handleFailedLoadImage} />
        : `${firstLetter}${secondLetter}`
      }
    </AvatarWrapper>
  );
};
